// extracted by mini-css-extract-plugin
export default {"body":"ViewOffer_body__RHSk0","container":"ViewOffer_container__oDK-u","main":"ViewOffer_main__QDxQb","Header":"ViewOffer_Header__86mBh"};